import { SOFTWARE_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import { useFeatures } from '@atlassian/jira-navigation-apps-sidebar-next-gen-use-features/src/controllers/features/index.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { generateNinBasePath } from '../../common/utils/index.tsx';
import type { IssueNavigatorLinkdResponse } from './types.tsx';

export const useIssueNavigatorLink = (): IssueNavigatorLinkdResponse => {
	const { data: projectContextData } = useProjectContext();
	const { data: features } = useFeatures();

	if (
		!projectContextData?.projectType ||
		!projectContextData?.projectKey ||
		typeof projectContextData?.simplified !== 'boolean'
	)
		return { issueNavigatorLink: null };

	const issueNavigatorLink = generateNinBasePath(
		projectContextData.projectKey,
		projectContextData.projectType,
		projectContextData.simplified,
	);

	// Service Desk and Business Projects have Issue Navigator feature permanently on
	let isIssueNavigatorEnabled = true;

	// Only Jira Software projects have the ability to toggle the Issue Navigator feature
	// TODO JSC-2619 Handled merged list/NIN feature toggles
	if (projectContextData.projectType === SOFTWARE_PROJECT) {
		isIssueNavigatorEnabled =
			(fg('jira_list_nin_merge') ? features?.hasList : features?.hasSIN) ?? false;
	}

	return { issueNavigatorLink: isIssueNavigatorEnabled ? issueNavigatorLink : null };
};
